import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

export interface AdminBranding {
  id: number;
  programTitle: string;
  programName: string;
  portalLabel: string;
  tagline: string;
  sidebarTitle: string;
  sidebarSubtitle: string;
  sidebarTagline: string;
  toolbarTitle: string;
  isActive: boolean;
  isActiveLabel: string;
  createdBy: number | null;
  createdByName: string;
  createdOn: string;
  updatedOn: string;
}

export interface AdminBrandingHistoryItem {
  id: number;
  programTitle: string;
  isActive: boolean;
  isActiveLabel: string;
  createdBy: number | null;
  createdByName: string;
  createdOn: string;
}

export type SaveAdminBrandingRequest = Pick<
  AdminBranding,
  | "programTitle"
  | "programName"
  | "portalLabel"
  | "tagline"
  | "sidebarTitle"
  | "sidebarSubtitle"
  | "sidebarTagline"
  | "toolbarTitle"
>;

export interface SaveAdminBrandingResponse {
  branding: AdminBranding;
  changed: boolean;
  message: string;
}

@Injectable({
  providedIn: "root",
})
export class AdminBrandingService {
  constructor(private api: ApiService) {}

  getActive(): Observable<AdminBranding> {
    return this.api.getPath<AdminBranding>("admin-branding");
  }

  getHistory(): Observable<AdminBrandingHistoryItem[]> {
    return this.api.getPath<AdminBrandingHistoryItem[]>("admin-branding/history");
  }

  save(request: SaveAdminBrandingRequest): Observable<SaveAdminBrandingResponse> {
    return this.api.putPath<SaveAdminBrandingResponse>("admin-branding", request);
  }
}
